import { render, staticRenderFns } from "./registerForm.vue?vue&type=template&id=4b619db0"
import script from "./registerForm.vue?vue&type=script&lang=ts"
export * from "./registerForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports